import { useReveal } from "@/hooks/useReveal";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_girl-activity-hub/artifacts/ohgdr8g2_Pink%20Black%20Simple%20Minimalist%20Aesthetic%20Ribbon%20Fashion%20Logo_20260702_100640_0000.png";

const BOX_IMAGE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_girl-activity-hub/artifacts/b71imasz_file_00000000ed1881fab37c45532a64bc78.png";

export default function Hero() {
  const logoRef = useReveal();
  const copyRef = useReveal();
  const visualRef = useReveal();

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-2 pb-16 sm:pt-4 sm:pb-24">
        {/* Big centered logo */}
        <div
          ref={logoRef}
          className="reveal flex flex-col items-center text-center"
          data-testid="hero-logo"
        >
          <img
            src={LOGO_URL}
            alt="Me Amor — Confidence Starts Here"
            className="w-64 sm:w-[24rem] lg:w-[30rem] h-auto object-contain -mb-16 sm:-mb-24 lg:-mb-36"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div
            ref={copyRef}
            className="reveal lg:col-span-6"
            data-testid="hero-copy"
          >
            <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#C48B9F]">
              <span className="w-6 h-px bg-[#C48B9F]" /> Confidence Starts Here
            </span>
            <h1 className="mt-6 font-serif-me text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-[#36292A]">
              Little boxes,{" "}
              <em className="italic text-[#C48B9F] font-normal">big love.</em>
              <br />
              Made for her.
            </h1>
            <p className="mt-8 max-w-xl text-[#7D6B6D] leading-relaxed text-base sm:text-lg">
              Me Amor curates seasonal gift boxes for girls aged 4 to 15 — from
              thoughtful pen-pal keepsakes to birthday celebrations and glam
              activity kits. Each box is a small ritual of self-love and
              delight.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#boxes"
                className="me-btn-primary"
                data-testid="hero-cta-shop"
              >
                Shop the boxes
              </a>
              <a
                href="#newsletter"
                className="me-btn-ghost"
                data-testid="hero-cta-newsletter"
              >
                Join the Pen Pal Club
              </a>
            </div>

            <div className="mt-14 flex items-center gap-8 text-xs tracking-[0.2em] uppercase text-[#7D6B6D]">
              <div>
                <div className="font-serif-me text-3xl not-italic text-[#36292A] tracking-normal">
                  4–15
                </div>
                <div className="mt-1">Ages</div>
              </div>
              <div className="h-10 w-px bg-[#E8D7D0]" />
              <div>
                <div className="font-serif-me text-3xl not-italic text-[#36292A] tracking-normal">
                  04
                </div>
                <div className="mt-1">Seasons</div>
              </div>
              <div className="h-10 w-px bg-[#E8D7D0]" />
              <div>
                <div className="font-serif-me text-3xl not-italic text-[#36292A] tracking-normal">
                  ∞
                </div>
                <div className="mt-1">Sparkle</div>
              </div>
            </div>
          </div>

          <div
            ref={visualRef}
            className="reveal lg:col-span-6 relative"
            data-testid="hero-visual"
          >
            <div className="relative">
              <div className="absolute -inset-6 sm:-inset-10 bg-[#F9F6F0] rounded-[40px] rotate-[-2deg]" />
              <div className="absolute -top-6 -right-4 hidden sm:block">
                <div className="font-serif-me italic text-[#C48B9F] text-2xl rotate-6">
                  — hello, sunshine
                </div>
              </div>
              <div className="relative overflow-hidden rounded-[32px] border border-[#E8D7D0] bg-white grain">
                <img
                  src={BOX_IMAGE}
                  alt="Me Amor Spring Glam Box featuring scrunchies, a hair bow, a mirror and a keepsake notebook"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className="text-xs tracking-[0.28em] uppercase text-[#7D6B6D]">
                    Featured
                  </div>
                  <div className="mt-1 font-serif-me text-2xl text-[#36292A]">
                    Spring Glam Box
                  </div>
                </div>
                <div className="hidden sm:block">
                  <div className="text-xs tracking-[0.28em] uppercase text-[#7D6B6D]">
                    Season 01
                  </div>
                  <div className="mt-1 font-serif-me text-2xl text-[#36292A]">
                    Primavera
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Rose ornament */}
      <div className="pointer-events-none absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#E1C6C1] opacity-40 blur-3xl" />
    </section>
  );
}
